/**
 * epgTimelineLabel.tsx
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimelineLabel = styled.div`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${26 * Screen.widthRatio}px;
`;

export default EpgTimelineLabel;
